"use client";
import React from "react";
import SmoothScrollbar from "@/components/ui/SmoothScrollbar";
import Project from "@/components/OurWork/OurWork";

export default function page() {
  return (
    <SmoothScrollbar>
      <Project />
    </SmoothScrollbar>
  );
}
